/**
 * Triggers haptic feedback on supported devices.
 * Currently a stub — will be implemented when targeting mobile/PWA.
 * Call on interactive element clicks (buttons, links, toggles).
 */
export function triggerHaptic(): void {
  // Stub for future haptic feedback implementation
}
